exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-414c78f9] {\n  background: #fff;\n  padding: 5px 0;\n}\n.pagination-container.hidden[data-v-414c78f9] {\n  display: none;\n}\n", ""]);

// exports
